import { render, staticRenderFns } from "./teaBookResource.vue?vue&type=template&id=454b0234&scoped=true"
import script from "./teaBookResource.vue?vue&type=script&lang=js"
export * from "./teaBookResource.vue?vue&type=script&lang=js"
import style0 from "./teaBookResource.vue?vue&type=style&index=0&id=454b0234&prod&lang=scss&scoped=true"
import style1 from "./teaBookResource.vue?vue&type=style&index=1&id=454b0234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b0234",
  null
  
)

export default component.exports